import {useEffect} from "react";
import {loadTossPayments} from "@tosspayments/tosspayments-sdk";
import {useRecoilValue} from "recoil";
import {accountSelector} from "../../store/selector/selector";

/** 토스 **클라이언트** 키(공개값). 시크릿 키는 서버에만 있다(`TossApiKey`). */
export const TOSS_CLIENT_KEY = "live_ck_oeqRGgYO1r5q1QwOjmOrQnN2Eyaz";

/**
 * 토스 카드(빌링키) 등록창을 띄운다 — **전체 페이지 이동**이다. 등록이 끝나면 `successUrl` 로 돌아오고,
 * 토스가 그 주소에 `customerKey`·`authKey` 쿼리를 붙인다.
 *
 * 🔑 호출부가 둘이다(2026-10-12): '결제 정보' 화면(이 파일의 컴포넌트)과 **가입 위저드 (4)→(5)**.
 *    위저드는 `/payments` 가 아니라 `/payments/toss/billing/wizard` 로 돌아와야 (6) 결제 화면으로 이어진다.
 *    같은 함수를 쓰고 복귀 주소만 다르게 준다 — SDK 호출을 두 곳에 복제하면 키·옵션이 어긋난다.
 *
 * @returns 사용자가 창을 닫는 등 **실패·취소**일 때만 resolve 되는 Promise(성공은 페이지가 떠난다).
 */
export const requestCardBillingAuth = async ({customerName, successPath, failPath}) => {
    const tossPayments = await loadTossPayments(TOSS_CLIENT_KEY);
    const payment = tossPayments.payment({customerKey: `${Date.now()}`});
    // 위저드는 계정 이름을 모른다(recoil 밖) — 없으면 아예 싣지 않는다(토스 SDK 는 `undefined` 값도 검사한다).
    return payment.requestBillingAuth({
        method: 'CARD',
        successUrl: window.location.origin + successPath,
        failUrl: window.location.origin + (failPath ?? successPath),
        ...(customerName ? {customerName} : {}),
    });
};

const CardRegistrationPopup = ({show, onCancel}) => {
    const account = useRecoilValue(accountSelector);

    useEffect(() => {
        if (show) {
            requestCardBillingAuth({
                customerName: account.name,
                successPath: '/payments/toss/billing',
            }).catch((reason) => onCancel(reason))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show])

    return (<></>)
}

export default CardRegistrationPopup
